import * as React from "react";
import { Button, Input, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  existingComment: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "8px",
    marginTop: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    borderLeft: "3px solid #0078d4",
  },
  commentLabel: {
    fontSize: "11px",
    fontWeight: "bold",
    color: "#666",
  },
  commentText: {
    fontSize: "12px",
    color: "#333",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  commentInput: {
    display: "flex",
    gap: "8px",
    marginTop: "12px",
    alignItems: "stretch",
  },
  input: {
    flex: 1,
    fontSize: "12px",
  },
});

type CardCommentSectionProps = {
  showCommentInput: boolean;
  commentText: string;
  isEditingComment: boolean;
  isPending: boolean;
  onCommentChange: (value: string) => void;
  onEditComment: () => void;
  onSendComment: () => void;
  onFocus: () => void;
};

export const CardCommentSection: React.FC<CardCommentSectionProps> = ({
  showCommentInput,
  commentText,
  isEditingComment,
  isPending,
  onCommentChange,
  onEditComment,
  onSendComment,
  onFocus,
}) => {
  const styles = useStyles();

  if (!showCommentInput) return null;

  if (commentText && !isEditingComment) {
    return (
      <div className={styles.existingComment}>
        <div className={styles.commentLabel}>Correct answer:</div>
        <div className={styles.commentText}>{commentText}</div>
        <Button onClick={onEditComment} appearance="subtle" size="small">
          Edit
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.commentInput}>
      <Input
        placeholder="Correct answer (optional)"
        value={commentText}
        onChange={(_e, data) => onCommentChange(data.value)}
        onFocus={onFocus}
        appearance="outline"
        className={styles.input}
      />
      <Button
        onClick={onSendComment}
        disabled={!commentText.trim() || isPending}
        appearance="primary"
        size="small"
      >
        {isPending ? "Sending..." : "Send"}
      </Button>
    </div>
  );
};
